import React, { useEffect } from "react";
import { Link, useLocation } from "react-router-dom";
import "./OurSolutions.css";
import Backup from "../../assest/solutions/Backup and DR card.png";
import Enterprise from "../../assest/solutions/Enterprise S card.png";
import Hyperconverge from "../../assest/solutions/Hyper-Converged-Infrastructure.jpg";
import Network from "../../assest/solutions/Network and wifi card.png";
import Loganalytic from "../../assest/solutions/Log analytic​ card.png";
import Virtualization from "../../assest/solutions/Virtualization​.png";
import VirtualizationHPEVME from "../../assest/solutions/Virtualization – HPE VME.png";
import Opensource from "../../assest/solutions/Opensource ERP.png";
import Security from "../../assest/solutions/Security.png";
import Firewall from "../../assest/solutions/Firewall 1.png";
import Privilege from "../../assest/solutions/PAM.png";
import VAScan from "../../assest/solutions/VA Scan.png";
import AutomatePentest from "../../assest/solutions/Automate Pentest 2.png";
import MicrosoftPowerPlatform from "../../assest/solutions/microsoft power platform.webp";
import GitlabDevOps from "../../assest/solutions/Gitlab DevOps.png";
import KatalonTestAutomation from "../../assest/solutions//katalon test automation.png";
const OurSolutions = () => {
  const location = useLocation();

  useEffect(() => {
    const hash = location.hash.replace("#", "");
    if (hash) {
      const section = document.getElementById(hash);
      if (section) {
        section.scrollIntoView({ behavior: "smooth" });
      }
    }
  }, [location]);

  return (
    <div className="solutions-wrapper">
      <h2 id="Infrastructure" className="solutions-heading">
        Infrastructure
      </h2>
      <br />
      <br />
      <div className="solutions-list">
        <div className="solution-item">
          <img src={Backup} alt="Backup and Disaster Recovery" />
          <h3>Backup and Disaster Recovery</h3>
          <p>Three Copies, Two Media Type, One Offsite</p>
          <div>
            <Link to="/backupanddisaster">
              <button className="custom-button">Read more</button>
            </Link>{" "}
          </div>
        </div>
        <div className="solution-item">
          <img src={Enterprise} alt="Enterprise Search" />
          <h3>Enterprise Search</h3>
          <p>Comprehensive Indexing, Instant Results</p>
          <div>
            <Link to="/enterprisesearch">
              <button className="custom-button">Read more</button>
            </Link>{" "}
          </div>
        </div>
        <div className="solution-item">
          <img src={Hyperconverge} alt="Hyperconverge" />
          <h3>Hyperconverge</h3>
          <p>Unified Infrastructure, Streamlined Management</p>
          <div>
            <Link to="/hyperconverge">
              <button className="custom-button">Read more</button>
            </Link>{" "}
          </div>
        </div>
        <div className="solution-item">
          <img src={Network} alt="Network and Wifi" />
          <h3>Network and Wifi</h3>
          <p>Seamless Connectivity, Reliable Performance</p>
          <div>
            <Link to="/networkandwifi">
              <button className="custom-button">Read more</button>
            </Link>
          </div>
        </div>
        <div className="solution-item">
          <img src={Loganalytic} alt="Log analytic" />
          <h3>Log analytic</h3>
          <p>Centralized Monitoring, Actionable Insights</p>
          <div>
            <Link to="/loganalytic">
              <button className="custom-button">Read more</button>
            </Link>
          </div>
        </div>
        <div className="solution-item">
          <img src={Virtualization} alt="Virtualization" />
          <h3>Virtualization</h3>
          <p>Consolidated Resources, Enhanced Efficiency</p>
          <div>
            <Link to="/virtualization">
              <button className="custom-button">Read more</button>
            </Link>
          </div>
        </div>
        <div className="solution-item">
          <img src={VirtualizationHPEVME} alt="HPE Morpheus VM Essentials Software" />
          <h3> HPE Morpheus VM Essentials Software</h3>
          <p></p>
          <div>
            <Link to="/hpe-morpheus-vm-essentials-software">
              <button className="custom-button">Read more</button>
            </Link>
          </div>
        </div>
      </div>

      <br />
      <br />

      <h2 id="Opensource" className="solutions-heading">
        Opensource ERP
      </h2>
      <br />
      <br />
      <div className="solutions-list">
        <div className="solution-item">
          <img src={Opensource} alt="Opensource ERP" />
          <h3>Opensource ERP</h3>
          <p>Customizable Solutions, Cost-Effective Implementations</p>
          <div>
            <Link to="/opensourceerp">
              <button className="custom-button">Read more</button>
            </Link>
          </div>
        </div>
      </div>

      <br />
      <br />

      <h2 id="Security" className="solutions-heading">
        Security
      </h2>
      <br />
      <br />
      <div className="solutions-list">
        <div className="solution-item">
          <img src={Security} alt="Security" />
          <h3>Security</h3>
          <div>
            <Link to="/security">
              <button className="custom-button">Read more</button>
            </Link>
          </div>
        </div>
        <div className="solution-item">
          <img src={Firewall} alt="Firewall" />
          <h3>Firewall</h3>
          <p>Fortify Your Perimeter, Control Network Traffic</p>
          <div>
            <Link to="/firewall">
              <button className="custom-button">Read more</button>
            </Link>
          </div>
        </div>
        <div className="solution-item">
          <img src={Privilege} alt="Privilege Access Management" />
          <h3>Privilege Access Management</h3>
          <p>Secure Access, Manage Permissions Effectively</p>
          <div>
            <Link to="/privilegeaccessmanagement">
              <button className="custom-button">Read more</button>
            </Link>
          </div>
        </div>
        <div className="solution-item">
          <img src={VAScan} alt="VA Scan" />
          <h3>VA Scan</h3>
          <p>Identify Vulnerabilities, Strengthen Security Posture</p>
          <div>
            <Link to="/vascreen">
              <button className="custom-button">Read more</button>
            </Link>
          </div>
        </div>
        <div className="solution-item">
          <img src={AutomatePentest} alt="Automate Pentest" />
          <h3>Automate Pentest</h3>
          <p>Proactive Security, Continuous Vulnerability Assessmen</p>
          <div>
            <Link to="/automatepentest">
              <button className="custom-button">Read more</button>
            </Link>
          </div>
        </div>
      </div>

      <br />
      <br />
      <h2 id="Development" className="solutions-heading">
        Development
      </h2>
      <br />
      <br />
      <div className="solutions-list">
        <div className="solution-item">
          <img src={MicrosoftPowerPlatform} alt="MicrosoftPowerPlatform" />
          <h3>Microsoft Power Platform </h3>
          <p>Accelerate Development, Drive Innovation</p>
          <div>
            <Link to="/microsoftpowerplatform">
              <button className="custom-button">Read more</button>
            </Link>
          </div>
        </div>

        <div className="solution-item">
          <img src={GitlabDevOps} alt="Gitlab DevOps" />
          <h3>Gitlab DevOps</h3>
          <p>Streamline Collaboration, Automate Software Delivery</p>
          <div>
            <Link to="/gitlabdevops">
              <button className="custom-button">Read more</button>
            </Link>
          </div>
        </div>

        <div className="solution-item">
          <img src={KatalonTestAutomation} alt="Katalon Test Automation" />
          <h3>Katalon Test Automation</h3>
          <p>Ensure Quality, Accelerate Testing Efforts</p>
          <div>
            <Link to="/katalontestautomation">
              <button className="custom-button">Read more</button>
            </Link>
          </div>
        </div>
      </div>
    </div>
  );
};

export default OurSolutions;
